export const CLIM_FIELDS = [
  {
    field: "nb_pieces",
    label: "Combien de pièces souhaitez-vous climatiser ? *",
    options: ["1 pièce", "2-3 pièces", "Toute la maison", "Je ne sais pas encore"],
    testPrefix: "clim-pieces",
  },
  {
    field: "chauffage_actuel",
    label: "Chauffage actuel *",
    options: ["Électrique", "Gaz", "Mazout", "Pompe à chaleur", "Autre"],
    testPrefix: "clim-chauffage",
  },
  {
    field: "type_logement",
    label: "Type d'habitation *",
    options: ["Maison", "Appartement"],
    testPrefix: "clim-logement",
  },
  {
    field: "delai",
    label: "Délai souhaité *",
    options: ["Dès que possible", "Avant l'été", "Dans les 6 mois", "Je me renseigne"],
    testPrefix: "clim-delai",
  },
];

export const PV_FIELDS = [
  {
    field: "type_toiture",
    label: "Type de toiture *",
    options: ["Tuiles", "Ardoises", "Toit plat", "Autre"],
    testPrefix: "pv-toiture",
  },
  {
    field: "conso_annuelle",
    label: "Consommation électrique annuelle *",
    options: ["Moins de 3 500 kWh", "3 500 à 5 000 kWh", "Plus de 5 000 kWh", "Je ne sais pas"],
    testPrefix: "pv-conso",
  },
  {
    field: "chauffage_electrique",
    label: "Chauffez-vous à l'électricité ? *",
    options: ["Oui", "Non"],
    testPrefix: "pv-chauffage",
  },
  {
    field: "batterie",
    label: "Intéressé par une batterie ? *",
    options: ["Oui", "Non", "À discuter"],
    testPrefix: "pv-batterie",
  },
  {
    field: "statut_occupant",
    label: "Vous êtes *",
    options: ["Propriétaire", "Locataire"],
    testPrefix: "pv-statut",
  },
];

export const buildClimQualification = (d) => ({
  type_projet: `Climatisation réversible — ${d.type_logement}, ${d.nb_pieces}, chauffage ${d.chauffage_actuel.toLowerCase()}, délai : ${d.delai.toLowerCase()}`,
  type_bien: d.type_logement,
  surface: d.nb_pieces,
  urgence: d.delai,
});

export const buildPVQualification = (d) => ({
  type_projet: `Photovoltaïque — Toiture ${d.type_toiture.toLowerCase()}, conso ${d.conso_annuelle.toLowerCase()}/an, chauffage électrique : ${d.chauffage_electrique.toLowerCase()}, batterie : ${d.batterie.toLowerCase()}, ${d.statut_occupant.toLowerCase()}`,
  type_bien: `Toiture ${d.type_toiture.toLowerCase()}`,
  surface: `Conso ${d.conso_annuelle}/an`,
});
